module.exports = __webpack_public_path__ + "static/media/Florida Department of Health Logo.627a3986.jpg";